// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__1ypEv","boxTitle":"Qualiphy_boxTitle__1uAsW","box":"Qualiphy_box__kjqR4","toggleWrap":"Qualiphy_toggleWrap__164xl"};